{
  "version": 1,
  "asset_id": "198d7f70-3c88-4dc0-b84e-b9758b8bb767",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/198d7f70-3c88-4dc0-b84e-b9758b8bb767/loc-the-woodlands-1280.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/198d7f70-3c88-4dc0-b84e-b9758b8bb767/loc-the-woodlands-1280.avif",
  "original_filename": "loc-the-woodlands-1280.avif",
  "size": 80513,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:34Z"
}
